const baseState = {
    data: null
}

const blockchainVerificationResultReducer = (state = baseState, { type, payload }) => {

    switch (type) {
        case "SET_BLOCKCCHAIN_VERIFY_RESULTS": {
            return {
                ...state,
                data: payload
            }
        }

        case "CLEAR_BLOCKCCHAIN_VERIFY_RESULTS": {
            return {
                ...state,
                data: null
            }
        }

        default:
            return state;
    }
}

export default blockchainVerificationResultReducer